export const relic = [
  {
    path: '/relic',
    name: 'Relic',
    component: () => import('../views/relic/relic.vue'),
    meta: {
      authorizationLimit: false,
      addText: '添加历史建筑',
      searchPlaceholder: '编号、名称、年代、类别、保护级别'
    }
  },
  {
    path: '/relic/:id',
    name: 'RelicDetail',
    component: () => import('../views/relic/relic-detail.vue'),
    meta: {
      authorizationLimit: false
    }
  },
  {
    path: '/relic/model/:id',
    name: 'Model',
    component: () => import('../views/model.vue'),
    meta: {
      authorizationLimit: false
    }
  }
  // {
  //   path: '/relic/report/:id/:name/:fromUserID',
  //   name: 'ReportDetail',
  //   component: () => import('../views/report/report-list.vue'),
  //   meta: {
  //     authorizationLimit: false,
  //     addText: '添加巡查记录',
  //     searchPlaceholder: '按编号、名称、巡查人搜索'
  //   }
  // }
];
